'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { ELEMENT, LAYOUT, SECTION, RESIZE_HANDLE, SAVE_SECTION } from 'LayoutBuilderUI/lib/DragDropConstants';
import PerformantDragLayer from 'layout-dnd-components/PerformantDragLayer';
import GenericDragPreview from 'LayoutBuilderUI/components/GenericDragPreview';
import { NativeTypes } from 'react-dnd-ipeui-backend';
import { DRAG_PREVIEW_HEIGHT_PX, DRAG_PREVIEW_WIDTH_PX } from 'LayoutBuilderUI/utils/DragDropUtils';
import { NamespaceWrapper } from 'EmailEditorUI/components/NamespaceWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const NATIVE_TYPES = Object.keys(NativeTypes).map(t => NativeTypes[t]);
const VALID_DROP_ITEM_TYPES = [ELEMENT, LAYOUT, SECTION, RESIZE_HANDLE, SAVE_SECTION];
class EditorDragLayer extends Component {
  shouldRender() {
    const {
      isDragging,
      itemType,
      item: {
        shouldUsePreview = true
      }
    } = this.props;
    if (!shouldUsePreview) {
      return false;
    }
    return isDragging && VALID_DROP_ITEM_TYPES.includes(itemType);
  }
  renderDragPreviewForType() {
    switch (this.props.itemType) {
      case RESIZE_HANDLE:
        return null;
      default:
        return /*#__PURE__*/_jsx(NamespaceWrapper, {
          children: /*#__PURE__*/_jsx(GenericDragPreview, {})
        });
    }
  }
  render() {
    if (!this.shouldRender()) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      style: {
        pointerEvents: 'none'
      },
      children: this.renderDragPreviewForType()
    });
  }
}
EditorDragLayer.propTypes = {
  isDragging: PropTypes.bool,
  itemType: PropTypes.oneOf([...VALID_DROP_ITEM_TYPES, ...NATIVE_TYPES]),
  item: PropTypes.object
};
export default PerformantDragLayer(monitor => ({
  isDragging: monitor.isDragging(),
  item: monitor.getItem(),
  itemType: monitor.getItemType()
}), {
  zIndex: 2,
  dragPreviewHeightPx: DRAG_PREVIEW_HEIGHT_PX,
  dragPreviewWidthPx: DRAG_PREVIEW_WIDTH_PX
})(EditorDragLayer);